<template>
  <v-card flat class="card">
    <div class="title">
        <span>
            Cancelar plano
        </span>
    </div>
    <div class="plano">
      <span>
          <span class="strong">Plano</span> Kristal <span class="strong-2" :style="{color: planInfo.color }">{{planInfo.title}}</span>
      </span>
    </div>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      user: undefined,
    };
  },
  props:{
      planInfo: {type: Object, default: undefined},
      userInfo: {type: Object, default: undefined}
  },
};
</script>

<style  scoped>
.card {
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border: 1px solid #dadada;
  border-radius: 7px;
}
figure {
  height: 100px;
  width: 100px;
  overflow: hidden;
}
figure .profile-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.perfil > div {
  margin: 0.3rem 0;
}
 .title span {
  font-weight: 700;
  font-size: 1.2em;
}
.perfil .w-300 span {
  font-weight: 300;
}
.strong{
    font-weight: 600;
    color: black;
}
.strong-2{
   font-weight: 500;
}

@media screen and (max-width: 480px) {
  .card {
    justify-content: center;
    text-align: center;
  }
}
</style>